import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { Sale, SaleRequest } from "../../../../service/model/store.model";
import { useState } from "react";
import SaleForm from "./sale-form";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { deleteSale, updateSale } from "../sale.slice";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import TableActionButton from "../../../../components/table/table-action-button";
import { DeleteIcon, EditIcon } from "../../../../shared/icons";

interface TableRowProps {
    readonly sale: Sale
}

const SaleTableRow: React.FC<TableRowProps> = ({ sale }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showSaleForm, setShowSaleForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(deleteSale(sale.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: SaleRequest) => {
        loggedInUser && dispatch(updateSale({ ...data, id: sale.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowSaleForm(false);
            }
        });
    };

    const calculateTotalAmount = (sale: Sale): number => {
        return sale.saleItems?.reduce((total, item) => total + item.totalAmount, 0);
    }

    return (
        <>
            <StyledTableRow key={sale.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Sale Date</Box>{sale.saleDate}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Total Amount</Box>{calculateTotalAmount(sale)}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Items</Box>{sale.saleItems?.length}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowSaleForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                </TableCell>
            </StyledTableRow>
            {showSaleForm &&
                <SaleForm sale={sale} editable={false} onClose={() => setShowSaleForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default SaleTableRow;